import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { MonCompteState } from './state';

export const getters: GetterTree<MonCompteState, RootState> = {
};
